import { RadioButtonBoolean } from '@repo/design-system-kit/components/radio-button-boolean/radio-button-boolean';
import {
  RadioGroupBoolean,
  type RadioGroupBooleanProps,
} from '@repo/design-system-kit/components/radio-group-boolean/radio-group-boolean';
import { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

const RADIO_GROUP_ID = 'pep-radio-group';

type GroupProps = Omit<
  RadioGroupBooleanProps,
  'children' | 'className' | 'label' | 'labelClassName'
>;

export interface PepRadioButtonProps extends GroupProps {
  className?: string;
  title?: string;
  subtitle?: string;
}

export function PepRadioButton({
  className,
  title,
  subtitle,
  ...props
}: PepRadioButtonProps): ReactNode {
  return (
    <div className={className} data-test-pep-section>
      <h2 className="body-standard mb-8" data-test-pep-title id={`${RADIO_GROUP_ID}-label`}>
        {title || <FormattedMessage id="shared-kit.pep-radio-button.title" />}
      </h2>

      <p className="caption mb-8" data-test-pep-description>
        {subtitle || <FormattedMessage id="shared-kit.pep-radio-button.subtitle" />}
      </p>

      <RadioGroupBoolean
        aria-labelledby={`${RADIO_GROUP_ID}-label`}
        data-test-pep-radio-group
        id={RADIO_GROUP_ID}
        {...props}
      >
        <RadioButtonBoolean className="body-standard" data-test-pep-yes value>
          <FormattedMessage id="shared-kit.pep-radio-button.yes" />
        </RadioButtonBoolean>

        <RadioButtonBoolean className="body-standard" data-test-pep-no value={false}>
          <FormattedMessage id="shared-kit.pep-radio-button.no" />
        </RadioButtonBoolean>
      </RadioGroupBoolean>
    </div>
  );
}
